import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.25 3.76249H13.75V11.125C13.75 11.6458 13.5677 12.0885 13.2031 12.4531C12.8385 12.8177 12.3958 13 11.875 13H2.12498C1.60416 13 1.16145 12.8177 0.796862 12.4531C0.432287 12.0885 0.25 11.6458 0.25 11.125V3.76249ZM1.49999 5.01248V11.125C1.49999 11.3021 1.55989 11.4505 1.67969 11.5703C1.79948 11.6901 1.94791 11.75 2.12498 11.75H11.875C12.0521 11.75 12.2005 11.6901 12.3203 11.5703C12.4401 11.4505 12.5 11.3021 12.5 11.125V5.01248H1.49999ZM0.25 3.01249V1.75H4.87501V0.874994C4.87501 0.697919 4.9349 0.549481 5.05469 0.429681C5.17448 0.309894 5.32291 0.25 5.5 0.25H8.5C8.67709 0.25 8.82553 0.309894 8.94531 0.429681C9.0651 0.549481 9.12499 0.697919 9.12499 0.874994V1.75H13.75V3.01249H0.25Z",
		fill: "inherit"
	})
});
export default SvgPot;
